jQuery(document).ready(function ($) {
  function initTestimonialsSlider() {
    if ($(window).width() <= 768) {
      if (!$(".new-home-testimonials-benefits-container").hasClass("slick-initialized")) {
        $(".new-home-testimonials-benefits-container").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
          adaptiveHeight: false,
          variableWidth: false,
          centerMode: false,
          autoplay: true,       // ✅ Enable Autoplay
          autoplaySpeed: 3000,  // ✅ Slide changes every 3 seconds (adjust as needed)
          pauseOnHover: true,   // ✅ Pause when hovered
          pauseOnFocus: true,   // ✅ Pause when focused
        });
      }
    } else {
      if ($(".new-home-testimonials-benefits-container").hasClass("slick-initialized")) {
        $(".new-home-testimonials-benefits-container").slick("unslick");
      }
    }
  }

  // Initialize on page load
  initTestimonialsSlider();

  // Reinitialize on window resize
  $(window).on("resize", function () {
    initTestimonialsSlider();
  });
});